module.exports = __webpack_public_path__ + "static/media/tettigonia_cantans_006_APA.90b72489.mp3";